import React, { Component } from 'react';
import Dialog, { DialogTitle, DialogContentText, DialogContent } from 'material-ui/Dialog';
import App from './App';
import SubscriptionManager from "./SubscriptionManager";
import context from './api/context';

export default class Root extends Component {

  state = {};
  subs = new SubscriptionManager();

  componentWillMount() {
    context.web3.then((w3) => {
      this.setState({
        web3Detected: w3 !== null,
        loaded: true
      })
    })
      .catch(() => this.setState({ loaded: true }))
    this.subs.subscribe(context.account, (account) => {
      if (!account._refreshing) {
        console.log("account is: ", account.account);
        this.setState({ account: account.account });
      }
    })
    this.subs.subscribe(context.network, (network) => {
      if (!network._refreshing) {
        console.log("network is: ", network.network);
        this.setState({ network: network.network });
      }
    })
  }

  componentWillUnmount() {
    this.subs.unsubscribe();
  }

  render() { //eslint-disable-line complexity
    const SimpleDialog = ({ title, text }) => (
      <Dialog open={true}>
        <DialogTitle>{title}</DialogTitle>
        <DialogContent>
          <DialogContentText>
            {text}
          </DialogContentText>
        </DialogContent>
      </Dialog>
    );

    if (this.state.account && this.state.network && this.state.network !== 'invalid') {
      return (<App />);
    } else if (this.state.loaded && !this.state.web3Detected) {
      return (<SimpleDialog title="No Ethereum Network Connection" text="Please use a MetaMask or otherwise Ethereum connected browser." />);
    } else if (this.state.network === 'invalid') {
      return (<SimpleDialog title="Beta Release" text="We only work on the Kovan Test Net for the moment..." />);
    } else if (this.state.error) {
      return (<SimpleDialog title="ERROR!" text={this.state.error} />);
    } else {
      return (<SimpleDialog title="Connecting to Ethereum..." text="Looking for connection" />);
    }
  }
}


// WEBPACK FOOTER //
// ./src/Root.js